
import { mapState } from "vuex";

export default {
  props: {
    headerIcons: { type: Array, default: () => [] },
  },

  data() {
    return {
      timerObj: null,
      title: {
        location: "Location",
        profile: "Become a Member",
        cart: "Cart",
      },
    };
  },

  computed: {
    ...mapState("app", ["isMegaMenuOpen", "activeMenuIndex"]),
    ...mapState("bag", ["miniCart"]),
    ...mapState("wishlist", ["wishlistItems", "modalTypes", "customer"]),
    showNotificationCount() {
      return Boolean(this.miniCart.lineItemsCount);
    },
    isCartPage() {
      return this.$route.path.includes("/cart");
    },
    cartItemCount() {
      return this.miniCart.lineItemsCount >= 100
        ? "99+"
        : this.miniCart.lineItemsCount;
    },
    wishlistItemCount() {
      return this.wishlistItems.length >= 100
        ? "99+"
        : this.wishlistItems.length;
    },
    isChildMenuOpened() {
      return (
        this.activeMenuIndex > -1 &&
        (this.$device.isMobileOrTablet || this.isTablet)
      );
    },
    isMegaMenuOpened() {
      return this.isMegaMenuOpen || this.isChildMenuOpened;
    },
    icons() {
      return this.headerIcons.filter(icon => icon.icon_name && icon.icon_link);
    },
  },

  methods: {
    checkDesktopAndNonCartPage(icon) {
      return this.$device.isDesktop && icon === "cart" && !this.isCartPage;
    },
    hideMegaMenu() {
      this.$store.dispatch("app/closeMegaMenu");
    },
    onMouseEnter(icon) {
      if (this.checkDesktopAndNonCartPage(icon)) {
        this.$emit("onCartIconMouseEnter");
      }
    },
    onMouseOut(icon) {
      if (this.checkDesktopAndNonCartPage(icon)) {
        this.$emit("onCartIconMouseLeave");
      }
    },
    handleClick(icon) {
      if (this.customer?.email) {
        const iconLink = this.$prismic.asLink(icon.icon_link);
        this.$router.push(iconLink);
        return;
      }

      if (icon.icon_name === "wishlist") {
        this.$store.dispatch("wishlist/openModal", {
          type: this.modalTypes.LOGIN_MODAL,
          modalOpenedFrom: "HEADER",
        });
      }
    },
  },
};
